import styled from '@emotion/styled';
import { colors } from 'folio-design-tokens';
import * as React from 'react';

const Message = styled.p`
  color: ${colors.wcagRed};
`;

export interface Props {
  id?: string;
  className?: string;
}

export const ErrorMessage: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  ...props
}) => <Message {...props}>{children}</Message>;
